import useOutsideClickDetection from '../hooks/useOutsideClickDetection';
import React, { useRef, useState } from 'react';
import PopUpMenu from './PopUpMenu';
import useClientRect from '../hooks/useClientReact';

export default function LinkedMenu({ children, itemType, onClickOutside, onMenuItemClick, trackValue, ...other }) {
  const [parent, ...menuItems] = React.Children.toArray(children);
  const [coords, setCoords] = useState({ left: 0, top: 0 });
  const popupMenuRef = useRef(null);
  const parentRef = useRef(null);
  const SelectableMenuItemClass = 'menu-item--selectable';

  function getCommonCoordinates(rect, { menuHeight, menuWidth},  { viewportHeight, viewportWidth }) {
    const canGoBottom = rect.bottom + menuHeight <= viewportHeight;
    const canGoUp = rect.top - menuHeight >= 0;
    const canGoLeft = rect.right - menuWidth >= 0;
    const canGoRight = rect.left + menuWidth <= viewportWidth;
    let commonCoords;
    if (canGoBottom && canGoRight) {
      commonCoords = {
        top: rect.bottom,
        left: rect.left
      };
    } else if (canGoBottom && canGoLeft) {
      commonCoords = {
        top: rect.bottom,
        left: Math.abs(rect.left - menuWidth + rect.width)
      };
    } else if (canGoUp && canGoRight) {
      commonCoords = {
        top: rect.top - menuHeight,
        left: rect.left
      };
    } else if (canGoUp && canGoLeft) {
      commonCoords = {
        top: rect.top - menuHeight,
        left: Math.abs(rect.left - menuWidth + rect.width)
      };
    }
    return commonCoords;
  }

  useClientRect((rect) => {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    const menuHeight = popupMenuRef.current && popupMenuRef.current.clientHeight || 30;
    const menuWidth = popupMenuRef.current && popupMenuRef.current.clientWidth || 30;

    const commonCoords = getCommonCoordinates(rect,
      { menuHeight, menuWidth },
      { viewportWidth, viewportHeight }
    );

    if (commonCoords) {
      setCoords(other.trackWidth ? {
        ...commonCoords,
        width: rect.width
      } : commonCoords);
    }
  }, parentRef, [other.show]);

  const onSelectableItemClick = (e) => {
    if (e.currentTarget.getAttribute('data-history')) {
      return;
    }

    if (typeof onMenuItemClick === 'function') {
      onMenuItemClick({
        itemType: itemType,
        itemIndex: Number(e.currentTarget.getAttribute('data-index'))
      });
    }

    if (typeof onClickOutside === 'function') {
      onClickOutside();
    }
  };

  useOutsideClickDetection(() => {
    typeof onClickOutside === 'function' && onClickOutside();
  }, [popupMenuRef]);

  return (
    <React.Fragment>
      {React.cloneElement(parent, {
        ref: parentRef
      })}
      <PopUpMenu coords={coords} ref={popupMenuRef} {...other}>
        {menuItems.map((item, index) => {
          const props = {};
          if (item.props.className.indexOf(SelectableMenuItemClass) >= 0) {
            props.onClick = onSelectableItemClick;
          }
          props['data-index'] = index;
          props['data-type'] = itemType;
          props['data-url'] = item.url;
          return React.cloneElement(item, props);
        })}
      </PopUpMenu>
    </React.Fragment>
  )
}
